import React from 'react'
import FactsCoffee from '../../components/Coffee/FactsCoffee'
import IntroCoffee from '../../components/Coffee/IntroCoffee'
import TypesCoffee from '../../components/Coffee/TypesCoffee'
import Layout from '../../components/Layout'
import Seo from '../../components/Seo'

export default function coffee({ location }) {
    return (
        <Layout location={location} >
            <Seo title="Zenith Pro | Grains" />
            <IntroCoffee />
            <FactsCoffee />
            <TypesCoffee />
        </Layout>
    )
}
